export enum ListingFeatureStatEnum {
  CALLS = 'calls',
  VIEWS = 'views',
  IMPRESSIONS = 'impressions',
}
